import { fetchThingsToDoShelfData } from '../thingsToDoShelf';

export const getRestOfContext =
    () => async (dispatch: (action: ReturnType<typeof fetchThingsToDoShelfData>) => void) => {
        dispatch(fetchThingsToDoShelfData());
    };
